export function getLessonsBySlug (lessonSlug) {
  return `
    query getAulasBySlug {
        ManualDoEnemAulas(filter:
          {
            _and: [
              {
              published: { _eq: true }
              },
              {slug: {_eq: "${lessonSlug}"}}
              ]
          }
        ){
            anchor
            author: author_id{
                id
                name
                surname
                avatar{
                  id
                  filename_disk
                  filename_download
                  title
                }
                biography
            }
            category{
                color
                id
                name
                slug
                status
            }
            cover_image{
                id
                filename_disk
                filename_download
                title
            }
            date_created
            date_updated
            exercises{
                answers
                explanation
                id
                origin
                question
            }
            id
            meta_description
            position
            published
            slug
            tags{
                ManualDoEnemTags_id{
                    id,
                    name
                }
            }
            text
            title
            videos
        }
    }
    `
    .replace('\n', '').trim().replace(/\s+/g, ' ')
}

export function getLessonsByTags (tags) {
  return `
    query getLessonsByTags {
        ManualDoEnemAulas(filter:
          {
            _and: [
              {
                published: { _eq: true }
              },
              {
                tags: {ManualDoEnemTags_id: {name: {_in: [${tags}]}}}
              }
            ]
          }
        ){
            cover_image{
                filename_disk
                filename_download
                title
                id
            }
            id
            slug
            title
        }
    }
      `
    .replace('\n', '').trim().replace(/\s+/g, ' ')
}

export function getLessonsByCategory (categorySlug) {
  return `
  query getAulas {
    ManualDoEnemAulas(sort: ["position", "title"], filter: {
      _and: [
          {
           published: { _eq: true }
          },
          {
            category: {slug: {_eq: "${categorySlug}"}}
          }
       ]
      }
    ){
        anchor
        author{
            id
            first_name
            last_name
            avatar{
                id
            }
        }
        category{
            color
            id
            name
            slug
            status
        }
        cover_image{
            filename_disk
            filename_download
            title
        }
        date_created
        date_updated
        exercises{
            answers
            explanation
            id
            origin
            question
        }
        id
        meta_description
        position
        published
        slug
        tags{
            ManualDoEnemTags_id{
                id,
                name
            }
        }
        text
        title
        videos
    }
}
  `.replace('\n', '').trim().replace(/\s+/g, ' ')
}

export function getCategories () {
  return `
      query getCategories {
        ManualDoEnemCategorias{
            id
            name
            slug
            color
        }
    }
  `.replace('\n', '').trim().replace(/\s+/g, ' ')
}

export function getAllLessons () {
  return `
    query getAllLessons {
      ManualDoEnemAulas(limit: -1, filter: { published: { _eq: true } }){
          published
          date_created
          slug
          category{
            id
            status
            slug
        }
      }
    }
`.replace('\n', '').trim().replace(/\s+/g, ' ')
}
